import React, { memo, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Input, Label } from 'reactstrap';

// The OnePay / manual choice for a refund action, shared across products (flights now, hotel
// later — onepay-refund.md §3.5): purely presentational, no product-specific text or data
// fetching. OnePay shows the amount BE will send (already formatted by the caller: this
// component never imports a product's own currency/amount helpers) and, while a pending
// ledger entry exists, a hint that a re-send is exactly the retry. Manual shows the gateway
// reference input as every resolve modal already collects it.
function RefundMethodField(props) {
  const {
    method, onMethodChange, amountLabel, gatewayRef, onGatewayRefChange, hasPendingRefund,
    forceManualOn,
  } = props;

  // forceManualOn increments (never toggles a bool) so the same rejection outcome can retrigger
  // it more than once in a row; 0 is the initial, unfired state.
  useEffect(() => {
    if (forceManualOn > 0) onMethodChange('MANUAL');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [forceManualOn]);

  return (
    <div className="mb-3">
      <div className="form-check mb-2">
        <Label className="form-check-label">
          <Input
            type="radio"
            name="refund-method"
            className="form-check-input"
            checked={method === 'ONEPAY'}
            onChange={() => onMethodChange('ONEPAY')}
          />
          Hoàn qua OnePay
        </Label>
      </div>
      <div className="form-check mb-2">
        <Label className="form-check-label">
          <Input
            type="radio"
            name="refund-method"
            className="form-check-input"
            checked={method === 'MANUAL'}
            onChange={() => onMethodChange('MANUAL')}
          />
          Đã hoàn thủ công, nhập mã giao dịch
        </Label>
      </div>
      {method === 'ONEPAY' ? (
        <>
          <div className="font-size-12 text-muted">{`Số tiền hoàn: ${amountLabel}`}</div>
          {hasPendingRefund && (
            <div className="font-size-12 text-warning mt-1">
              Có lệnh hoàn đang chờ OnePay, bấm xác nhận để kiểm tra lại
            </div>
          )}
        </>
      ) : (
        <>
          <Label htmlFor="refund-gateway-ref">Mã tham chiếu hoàn tiền trên cổng thanh toán *</Label>
          <Input
            id="refund-gateway-ref"
            value={gatewayRef}
            onChange={(e) => onGatewayRefChange(e.target.value)}
          />
        </>
      )}
    </div>
  );
}

RefundMethodField.propTypes = {
  method: PropTypes.oneOf(['ONEPAY', 'MANUAL']).isRequired,
  onMethodChange: PropTypes.func.isRequired,
  amountLabel: PropTypes.string.isRequired,
  gatewayRef: PropTypes.string.isRequired,
  onGatewayRefChange: PropTypes.func.isRequired,
  hasPendingRefund: PropTypes.bool,
  forceManualOn: PropTypes.number,
};

RefundMethodField.defaultProps = {
  hasPendingRefund: false,
  forceManualOn: 0,
};

export default memo(RefundMethodField);
